const styles: StyleObject & { modal: StyleObject } = {
  logo: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    mx: 'auto',
    mt: '40px',
    mb: '18px',
    justifyContent: 'center',
    alignItems: 'center',
    userSelect: 'none',
    gap: '8px',
    zIndex: 2,
  },
  background: {
    position: 'relative',
    backgroundImage: 'url(/static/images/byds/landing.jpg)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',

    '@media(max-height: 850px)': {
      minHeight: '850px',
    },

    ':before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '175px',
      background: 'linear-gradient(180deg, #f37021cc 0%, transparent 100%)',
    },

    ':after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '60vh',
      background: 'linear-gradient(0deg, black 0%, transparent 100%)',
    },
  },
  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    padding: '8px 32px',
    userSelect: 'none',
    minHeight: '750px',
    maxWidth: ['100dvw', null, '390px'],
    zIndex: 2,
  },
  title: {
    display: 'block',
    color: '#fff',
    textAlign: 'center',
    lineHeight: '100%',
    fontFamily: 'din-medium-cn',
    fontSize: '32px',
    fontStyle: 'italic',
    whiteSpace: 'wrap',
    userSelect: 'none',
    mt: 'auto',
    mx: 'auto',
    width: '100%',
    maxWidth: '390px',

    '&.de': {
      fontSize: '27px',
    },
  },
  summary: {
    textAlign: 'center',
    fontFamily: 'din-light-cn',
    fontSize: '20px',
    userSelect: 'none',
    fontStyle: 'italic',

    '&:last-of-type': {
      pb: '20px',

      '@media(max-height: 900px)': {
        pb: '120px',
      },
    },

    p: {
      marginBottom: 0,
    },
  },
  button: {
    mx: 'auto',
    fontSize: '18px',

    '@media(max-height: 900px)': {
      position: 'fixed',
      bottom: '30px',
      left: '50%',
      transform: 'translateX(-50%)',
    },
  },
  terms: {
    mx: 'auto',
    textAlign: 'center',
    userSelect: 'none',

    '@media(max-height: 900px)': {
      position: 'fixed',
      bottom: '10px',
      left: '50%',
      transform: 'translateX(-50%)',
    },

    a: {
      color: '#fff',
      fontFamily: 'din-light-cn',
      fontSize: '13px',
      textDecoration: 'underline',
    },

    p: {
      margin: 0,
    },
  },
  modal: {
    wrapper: {
      width: '310px',
      maxWidth: 'calc(100vw - 32px)',
      p: 0,
      background: 'transparent',
      borderRadius: '12px',
      overflow: 'hidden',

      '> div': {
        height: '100%',
      },

      '> div > div:first-of-type': {
        display: 'none',
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '22px',
      width: '100%',
      background: '#232323',
      p: '20px',
      borderRadius: '12px',
    },
    options: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: '10px',
      width: '300px',
      maxWidth: '100%',
    },
    title: {
      m: 0,
      width: '100%',
      height: '24px',
      color: 'bydb-white',
      fontFamily: 'bold',
      fontSize: '16px',
      fontStyle: 'italic',
      fontWeight: 600,
      lineHeight: '24px',
      letterSpacing: 0,
      textAlign: 'center',
    },
    regionGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      m: 0,
      p: 0,
      border: 0,
      minWidth: 0,
    },
    legend: {
      position: 'absolute',
      width: '1px',
      height: '1px',
      p: 0,
      m: '-1px',
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      border: 0,
    },
    regionOption: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      width: '300px',
      maxWidth: '100%',
      height: '24px',
      cursor: 'pointer',
      userSelect: 'none',

      'input:focus-visible + .region-checkbox': {
        boxShadow: '0 0 0 2px rgba(255, 255, 255, 0.35)',
      },

      'input:checked + .region-checkbox': {
        background: '#f37021',
        color: '#232323',
        borderColor: '#f37021',
      },

      'input:checked + .region-checkbox:after': {
        opacity: 1,
      },
    },
    checkbox: {
      position: 'relative',
      flex: '0 0 18px',
      width: '18px',
      height: '18px',
      border: '0.9px solid var(--theme-ui-colors-bydb-white)',
      borderRadius: '4px',

      ':after': {
        content: '""',
        position: 'absolute',
        left: '3px',
        top: '4px',
        width: '10px',
        height: '4px',
        borderLeft: '2px solid #fff',
        borderBottom: '2px solid #fff',
        transform: 'rotate(-45deg)',
        opacity: 0,
      },
    },
    regionLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      minWidth: 0,
      height: '24px',
      width: '100%',
    },
    flag: {
      display: 'block',
      flex: '0 0 29px',
      width: '29px',
      height: '18px',
      borderRadius: '2px',
      objectFit: 'cover',
    },
    regionText: {
      color: 'bydb-white',
      fontFamily: 'bold',
      fontSize: '16px',
      fontStyle: 'italic',
      fontWeight: 600,
      lineHeight: '24px',
      letterSpacing: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
      whiteSpace: 'nowrap',
    },
  },
}

export default styles
